import PropTypes from 'prop-types';
import {Tooltip} from '@material-ui/core';
import styles from './index.css';
import Button from '@material-ui/core/Button';
import {WarningIcon} from '../../Icon';
import React from 'react';
import {FormattedMessage} from 'react-intl';

export const TooltipWarningButton = ({warningMessage}) => {
    return (
        <Tooltip
            className={styles.warningTooltip}
            enterTouchDelay={0}
            title={
                <span style={{fontSize: 16}}>
                    {warningMessage}
                </span>
            }>
            <div className={styles.warningDiv}>
                <Button
                    color="primary"
                    disabled={true}
                    size="small"
                    style={{fontSize: 12}}
                    variant="contained"
                >
                    <FormattedMessage id={'labels.CREATE_ENVELOPE'}/>
                </Button>
                <WarningIcon/>
            </div>
        </Tooltip>
    )
};

TooltipWarningButton.propTypes = {
    warningMessage: PropTypes.string.isRequired
};
